<template>
    <div>
        <company-edit
            v-if="company"
            class       = "mb-3"
            :height     = "469"
            :company    = "company"
            :show-store = "showStore"
            :comment-rows = "8"
            ref         = "companyEditor"
            @stored     = "onStored"
        >
            <template v-slot:additional>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <v-text-field
                            label          = "Import Name"
                            v-model        = "company.idname"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </v-col>
                </v-row>
            </template>
            <template v-slot:roles>
                <v-row dense>
                    <v-col>

                    </v-col>
                </v-row>
                <v-select
                    v-model    = "company.roles"
                    :items     = "roles"
                    :rules     = "[rules.required]"
                    item-value = "id"
                    item-text  = "name"
                    label      = "Rollen"
                    @change    = "onChangeRoles"
                    return-object
                    multiple
                    chips
                    dense
                >
                    <template v-slot:item="data">
                        <div class="v-flex">
                            <div class="tag">
                                {{ data.item.label }}
                            </div>
                            <div class="pl-1">
                                {{ data.item.name }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:selection="data">
                        <c-tag
                            :label  = "data.item.label"
                            :active = "false"
                            class   = "mr-1"
                        />
                    </template>
                </v-select>
            </template>
        </company-edit>
    </div>
</template>

<script>

import CTag        from "@/modules/core/components/utils/CTag";
import Core        from "@/modules/core/service/Core";
import CompanyEdit from "@/modules/msd/company/common/components/controlls/CompanyEdit";

export default {
    name: "CServicepartnerEdit",

    components: {
        CompanyEdit,
        CTag,
    },

    props: {
        company: {

        },

        showStore: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        tab: 1,
        expandFilter: false,
        selectedRoles: null,
        roles: [
            { id: 13, name: "Hersteller",         label: "H" , value: false },
            { id:  2, name: "Facilitymanagement", label: "FM", value: false },
            { id:  3, name: "Wartungsnehmer",     label: "WM", value: false },
            { id:  4, name: "Notrufnehmer",       label: "NN", value: false },
            { id: 10, name: "Verwalter",          label: "VW", value: false },
            { id: 11, name: "Ausf. Unternehmen",  label: "AU", value: false },
            { id: 12, name: "Nur Komponenten",    label: "NK", value: false },
        ]
    }),

    computed: {
        rules () {
            return Core.rule;
        },
    },

    watch: {
        company () {
            this.setRoles();
        }
    },

    mounted() {
        this.setRoles();
    },

    methods: {
        setRoles () {
            this.selectedRoles = [];
            this.selectedRoles = this.company.roles;
        },

        onChangeRoles () {
            this.$emit("")
        },

        store (success, error) {
            this.$refs.companyEditor.onStore(success, error);
        },

        onStored (company) {
            this.$emit("stored", company)
        }
    }
}
</script>

<style scoped>

::v-deep .v-select__selections {
    min-height: 25px;
}

.tag {
    width: 25px;
    text-align: center;
    font-size: 11px;
    margin-top: 2px;
    height: 18px;
    border-radius: 2px;
    padding-top: 1px;
    border-style: solid;
    border-width: 1px;
    margin-right: 5px;
}

</style>